// 顧客宛文書詳細
import { ResponseKWANKGM10060A01, CustomerDocument } from '../types/CustomerDocumentDetail';

// 顧客宛文書
export const document_init: CustomerDocument = {
  id: 0,
  group_name: '',
  offices_name: '',
  title: '',
  comment: null,
  file_name: null,
  user_list: null,
  start_date: '',
  end_date: '',
  create_user_name: '',
  authorizer_name: '',
  authorizer_id: 0,
  status: '',
  updated_at: ''
}

// 承認ボタンを表示するステータス
// 未承認、削除承認待ち
export const can_approval_status = [ 1, 5 ];

// レスポンスのモック
export const mock: ResponseKWANKGM10060A01 = {
  data: {
    result: true,
    message: '',
    response_type: 31,
    detail: {
      customers_document: {
        id: 1,
        group_name: 'JA東京みどり',
        offices_name: 'サンプル店舗',
        title: '融資実行のご案内',
        comment: '融資実行が完了しました。詳細内容については添付ファイルをご確認ください。\n添付ファイルは、ダウンロードすることができます。',
        file_name: 'bunsho.pdf',
        user_list: [
          {
            user_id: 1,
            user_name: '文書太郎',
            email: 'sample@test.jp',
          }
        ],
        start_date: '2020-04-01',
        end_date: '2023-10-08',
        create_user_name: '登録太郎',
        authorizer_name: '職員一郎',
        authorizer_id: 501,
        status: 1,
        updated_at: '2020-03-01',
      }
    }
  }
};
